import { render, staticRenderFns } from "./JurisdictionComponent.vue?vue&type=template&id=2f34255a&scoped=true"
import script from "./JurisdictionComponent.vue?vue&type=script&lang=js"
export * from "./JurisdictionComponent.vue?vue&type=script&lang=js"
import style0 from "@/other/assets/css/app.css?vue&type=style&index=0&id=2f34255a&prod&scoped=true&lang=css&external"
import style1 from "./JurisdictionComponent.vue?vue&type=style&index=1&id=2f34255a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f34255a",
  null
  
)

export default component.exports